export default "__VITE_ASSET__755cc0f5__"